import React, { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
  };

  public static getDerivedStateFromError(_: Error): State {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Uncaught error:', error, errorInfo);
  }

  public render(): ReactNode {
    const { hasError } = this.state;
    const { children } = this.props;

    if (hasError) {
      return (
        <div className="flex flex-col justify-center items-center w-screen h-screen">
          <h5>Oops! Something went wrong. 😥</h5>
          <button
            type="button"
            className="btn btn-primary w-auto"
            onClick={() => window.location.reload()}
          >
            Please, reload the page
          </button>
        </div>
      );
    }

    return children;
  }
}

export default ErrorBoundary;
